import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { ceilNumber } from "@/utils/number";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

type FoundryFrameNames = FrameName.FOUNDRY | FrameName.INDUSTRIAL_FOUNDRY;

class FoundryBuildingTileEntity extends TileEntity {
	public static readonly frameName: FoundryFrameNames = FrameName.FOUNDRY;

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);

		let ironConsumption =
			(consumption.get(ResourceType.IRON_CONSUMPTION) as number) || 0;
		ironConsumption *=
			1 - getUpgradeCurrentReplaceValueById(UpgradeIds.ingots);
		ironConsumption = ceilNumber(ironConsumption);
		consumption.set(ResourceType.IRON_CONSUMPTION, ironConsumption);

		return consumption;
	}
}

export default FoundryBuildingTileEntity;
